import styled, { css } from 'styled-components';
import { getColorByName } from '~/helpers/getColors';
import MetaNavigationChildWrapper from '../MetaNavigation.skins';
import { gridGutter, mq } from '~/styles/grid';
import CTA from '~/components/atoms/CTA';

export const HeaderItemsCommonStyles = css`
  background: ${(props) =>
    getColorByName(props.theme, props.theme.header.bgColor)};
  color: ${({ theme }) => theme.color.deepHumanBlue100};
  font-size: ${(props) => props.theme.cta.primaryFontSize};
`;

export const Wrapper = styled.div`
  ${MetaNavigationChildWrapper};

  border-bottom: ${(props) => props.theme.header.dividerHorizontal};
`;

export const NavLeftDistance = 82;

export const LogoWrapper = styled.a`
  margin: 0 auto 0 ${NavLeftDistance}px;

  @media (${mq.lgDown}) {
    margin: 0 auto 0 ${gridGutter}px;
  }
`;

export const NavList = styled.ul`
  display: flex;
  align-items: center;
  gap: 20px;
`;

/**
 * @typedef {Object} FindJobCTAStyledProps
 * @property {string} [justifyContent]
 */

/** @type {import('styled-components').StyledComponent<typeof CTA, any, FindJobCTAStyledProps>} */
export const FindJobCTAStyled = styled(CTA)`
  ${(/** @type {FindJobCTAStyledProps & {theme: any}} */ props) => css`
    height: ${props.theme.header.height}px;
    & path {
      fill: ${getColorByName(
        props.theme,
        props.theme.header.ctaFindJobColor,
      )} !important;
    }
    & .text::after {
      background: ${getColorByName(
        props.theme,
        props.theme.header.ctaFindJobColor,
      )} !important;
    }
    a {
      justify-content: ${props.justifyContent || 'start'};
      padding: 24px;
      font-family: ${props.theme.font.bold} !important;
      color: ${getColorByName(
        props.theme,
        props.theme.header.ctaFindJobColor,
      )} !important;
      background: ${getColorByName(
        props.theme,
        props.theme.header.ctaFindJobBgColor,
      )} !important;
    }
    @media (${(props) => props.theme.teaserCareer.mobileSwitch}) {
      height: 56px;
      margin: 12px 0px 24px 0px;
      a {
        padding: 16px;
        font-size: 18px;
      }
      & svg {
        width: 18px;
        height: 18px;
        max-height: 18px !important;
      }
    }
  `}
`;

export const HeaderCTAsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  & > *:not(:last-child) {
    padding: 24px 16px 20px 16px;
    height: 24px;
  }
`;
